import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import ImageUpload from "@/components/admin/ImageUpload";

export default function AdminMedia() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/media").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    try {
      await api.delete(`/admin/media/${id}`);
      setItems((x) => x.filter((i) => i.id !== id));
      toast.success("Bild entfernt");
    } catch { toast.error("Fehler"); }
  };

  return (
    <div className="fade-in">
      <h1 className="font-serif text-4xl font-light mb-8">Medien</h1>

      <div className="bg-white border border-[#E7D8C6] p-6 mb-8">
        <h2 className="font-medium mb-4">Neue Bilder hochladen</h2>
        <ImageUpload value={[]} multiple onChange={() => load()} />
        <p className="text-xs text-[#9A86B4] mt-3">Unterstützt: JPEG, PNG, WebP, HEIC. Bilder werden automatisch fürs Web optimiert, EXIF-Daten entfernt.</p>
      </div>

      {items.length === 0 ? (
        <p className="text-[#9A86B4]">Noch keine Bilder hochgeladen.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-3">
          {items.map((m) => (
            <div key={m.id} className="relative bg-[#F3E7D2] aspect-square group" data-testid={`media-${m.id}`}>
              <img src={mediaUrl(m.id, true)} alt={m.original_filename} className="w-full h-full object-cover" />
              <button onClick={() => del(m.id)} className="absolute top-1.5 right-1.5 bg-[#F4C542] text-[#32104F] p-1.5 opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Löschen">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
